import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    FLEXCONTROLSFORMNAME: {
        id: 'FLEXCONTROLSFORMNAME',
        defaultMessage: 'Name is a required field',
    },
    FLEXCONTROLSFORMTYPE: {
        id: 'FLEXCONTROLSFORMTYPE',
        defaultMessage: 'Type is a required field',
    },
    FLEXCONTROLSFORMDENYCODE: {
        id: 'FLEXCONTROLSFORMDENYCODE',
        defaultMessage: 'Deny code is a required field',
    },
    FLEXCONTROLSFORMMAXLIMIT: {
        id: 'FLEXCONTROLSFORMMAXLIMIT',
        defaultMessage: 'Max limit is a required field',
    },
    FLEXCONTROLSFORMMAXLIMITNUM: {
        id: 'FLEXCONTROLSFORMMAXLIMITNUM',
        defaultMessage: 'Max limit must be a number',
    },
    FLEXCONTROLMONTHDAYRANGE: {
        id: 'FLEXCONTROLMONTHDAYRANGE',
        defaultMessage: 'Month day must be a number between 1 and 28',
    },
    FLEXCONTROLSDURATION: {
        id: 'FLEXCONTROLSDURATION',
        defaultMessage: 'Limit duration is required for usage/spending limits',
    },
    FLEXCONTROLSWEEK: {
        id: 'FLEXCONTROLSWEEK',
        defaultMessage: 'Week day is a required field',
    },
    FLEXCONTROLSMONTH: {
        id: 'FLEXCONTROLSMONTH',
        defaultMessage: 'Month day is a required field',
    },
    FLEXCONTROLSCONDITIONS: {
        id: 'FLEXCONTROLSCONDITIONS',
        defaultMessage:
            'At least one valid condition is required for a restriction control',
    },
    FLEXCONTROLSCONDITIONSATTRIBUTE: {
        id: 'FLEXCONTROLSCONDITIONSATTRIBUTE',
        defaultMessage:
            'A valid attribute is required for a restriction control',
    },
    FLEXCONTROLSCONDITIONSOPERATOR: {
        id: 'FLEXCONTROLSCONDITIONSOPERATOR',
        defaultMessage:
            'A valid operator is required for a restriction control',
    },
    FLEXCONTROLSCONDITIONSVALUE: {
        id: 'FLEXCONTROLSCONDITIONSVALUE',
        defaultMessage: 'A valid value is required for a restriction control',
    },
    FLEXCONTROLSCONDITIONSVALUEREQUIRED: {
        id: 'FLEXCONTROLSCONDITIONSVALUEREQUIRED',
        defaultMessage:
            'Please complete the value field to create a valid condition',
    },
    FLEXCONTROLSCONDITIONSOPERATORREQUIRED: {
        id: 'FLEXCONTROLSCONDITIONSOPERATORREQUIRED',
        defaultMessage:
            'Please complete the operator field to create a valid condition',
    },
    FLEXCONTROLSCONDITIONSATTRIBUTEREQUIRED: {
        id: 'FLEXCONTROLSCONDITIONSATTRIBUTEREQUIRED',
        defaultMessage:
            'Please complete the attribute field to create a valid condition',
    },
});

export default enumMessages;
